<template lang="pug">
.d-flex.fd-column
  v-autocomplete(
    :items='lista'
    v-model="idDireccion"
    label="Direccion"
    placeholder="Realiza la busqueda por la desripción"
    dense,
    item-value="id"
    item-text="direccion"
    return-object
    hide-details,
    @change="seleccionarClick"
  )
    template(v-slot:item='data')
      v-list.my-0.py-0(dense)
        v-list-item-content
          v-list-item-title.font-size-12(v-html='data.item.id')
          v-list-item-subtitle.font-size-11(v-html='data.item.direccion')
  small.mt-1.text-muted(v-if="idDireccion") {{idDireccion}}
</template>
<script>
// import cargandoLoad         from './Component_Cargando'
import { apiGet, notify }   from '../util/general.js'
export default {
  components :{
    // 'loading-global-sil': cargandoLoad
  },
  props: ['codigo', 'id'],
  data () {
    return {
      isLoading: false,
      lista    : [],
      filtro   : '',
      idDireccion : this.id || '',
      empresa  : process.env.EMPRESA
    }
  },
  watch : {
    filtro : function () {
      var vm = this
      vm.buscarValor()
    }
  },
  created () {
    var vm = this
    console.log('codigocodigo', vm.codigo)
    if (!vm.codigo) {
      notify(vm, 'error', 'Error', 'El codigo del cliente no esta definido')
      return
    }
    vm.fetch()
  },
  methods : {
    close () {
      this.$emit('close')
    },
    fetch () {
      var vm       = this
      vm.isLoading = true
      var url      = '/cliente/direccion/obtener'
      var obj = {
        codigoCliente : vm.codigo ? vm.codigo.toString().trim() : '',
        octopus       : true
      }
      apiGet(vm, url, obj, function (data) {
        console.log('data', data)
        vm.lista    = data.lista
        vm.filtered = data.lista
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isLoading = false
      })
    },
    seleccionarClick (o) {
      var vm = this
      console.log('ooo', o)
      vm.idDireccion = o.id
      vm.$emit('selected', o)
    },
    buscarValor () {
      var vm = this
      if (vm.filtro) {
        let value = vm.filtro + ''
        var valueBuscar = value ? value.toLowerCase() : ''
        vm.lista = vm.lista.filter(e => {
          var direccion = e.direccion ? e.direccion.toLowerCase() : ''
          var referencia = e.direccion ? e.direccion.toLowerCase() : ''
          return  direccion.includes(valueBuscar) || referencia.includes(valueBuscar)
        })
      } else vm.lista = vm.filtered
    }
  }
}
</script>




// WEBPACK FOOTER //
// c_direcciones_cliente_seleccionar.vue?72b8f868